import { gql } from "@apollo/client";

// Fetch the restricted vendors for a user BY ID (independent of the header
// org filter) together with the organization each vendor belongs to. Used on
// the User edit page so an admin can see which organizer a user's vendor is
// tied to — and spot when it differs from the user's own Organization, which
// is what makes that vendor invisible to the user (e.g. the Stripe Connect
// "vendor not found" case).
export const VENDOR_ORGANIZERS_BY_IDS = gql`
  query VendorOrganizersByIds($ids: [Int!]) {
    vendors(where: { id: { _in: $ids } }, order_by: { name: asc }) {
      id
      name
      is_active
      organization_id
      organization {
        id
        name
      }
    }
  }
`;

export const UsersListQuery = gql`
  query UsersList($where: users_bool_exp) {
    users(where: $where, order_by: { username: asc }) {
      id
      is_active
      username
      created_at
      updated_at
      first_name
      last_name
      events
      vendors
      role {
        id
        name
        display_name
      }
      phone_number
      vendor {
        id
        name
      }
      email
      tablet_access_code
      organization_id
      organization {
        id
        name
      }
      event_id
      users_event {
        id
        name
      }
      user {
        username
      }
    }
  }
`;

export const UsersListQueryEventFilter = gql`
  query UsersList($eventWhere: users_bool_exp) {
    users(where: $eventWhere, order_by: { username: asc }) {
      id
      is_active
      username
      created_at
      updated_at
      first_name
      last_name
      events
      vendors
      role_id
      role {
        id
        name
        display_name
      }
      phone_number
      vendor {
        id
        name
      }
      email
      tablet_access_code
      organization_id
      organization {
        id
        name
      }
      event_id
      users_event {
        id
        name
      }
      user {
        username
      }
    }
  }
`;

export const UserByPK = gql`
  query UserById($id: Int!) {
    users_by_pk(id: $id) {
      id
      is_active
      username
      created_at
      updated_at
      first_name
      last_name
      role_id
      role {
        name
      }
      phone_number
      email
      tablet_access_code
      organization_id
      events
      vendors
      event_id
      users_event {
        id
        name
      }
      vendor_id
      vendor {
        name
      }
      vendors
      events
    }
  }
`;

export const GET_LIST_EVENTS_BY_ORGANIZATION = gql`
  query EventsByOrganization($where: events_bool_exp!) {
    events(order_by: { name: asc }, where: $where) {
      id
      name
      location_zones
    }
  }
`;
